import { NativeType } from './enums';
import { initCallback, pushCallback } from './core/callback';
import { isEmpty } from './utils';
import { isIOS } from './env';

initCallback(NativeType.APP);

interface Param {
  classMap: string;
  method: string;
  params: any,
}

export const appCallNative = (params: Param) => {
  return new Promise((resolve, reject) => {
    const id = pushCallback({ resolve, reject });
    const data = {
      classMap: params.classMap,
      method: params.method,
      params: isEmpty(params.params) ? '' : JSON.stringify(params.params),
      callbackId: id.toString(),
    };
    const dataStr = JSON.stringify(data);
    if (isIOS) {
      (<any>window).webkit.messageHandlers.callNative.postMessage(dataStr);
    } else {
      (<any>window).AppFunctions.callNative(dataStr);
    }
  });
};
